//@ts-check
/**
MIT License

Copyright (c) 2017 Niladri

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
export enum RoundingModes {
  /**
   * Rounding mode to round towards positive infinity.
   */
  CEILING,

  /**
   * Rounding mode to round towards zero.
   */
  DOWN,

  /**
   * Rounding mode to round towards negative infinity.
   */
  FLOOR,

  /**
   * Rounding mode to round towards "nearest neighbor" unless both neighbors are equidistant,
   * in which case round down.
   */
  HALF_DOWN,

  /**
   * Rounding mode to round towards the "nearest neighbor" unless both neighbors are equidistant,
   * in which case, round towards the even neighbor.
   */
  HALF_EVEN,

  /**
   * Rounding mode to round towards "nearest neighbor" unless both neighbors are equidistant,
   * in which case round up.
   */
  HALF_UP,

  /**
   * Rounding mode to assert that the requested operation has an exact result, hence no rounding is necessary.
   * UNIMPLEMENTED
   */
  UNNECESSARY,

  /**
   * Rounding mode to round away from zero.
   */
  UP,
}
